import { Reveal } from "./Reveal";
import { MANIFESTO } from "../lib/data";

export const Approach = () => (
  <section id="approach" className="border-t border-[#262626]" data-testid="approach-section">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-24 lg:py-36">
      <div className="grid lg:grid-cols-12 gap-8 mb-16">
        <Reveal className="lg:col-span-6 lg:col-start-1">
          <span className="overline">The Approach</span>
          <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.02] mt-5 text-[#F7F5F2] text-balance">
            Four principles that guide every brief.
          </h2>
        </Reveal>
      </div>

      <div className="border-t border-[#262626]">
        {MANIFESTO.map((m, i) => (
          <Reveal key={m.no} delay={i * 0.06}>
            <div className="group grid md:grid-cols-12 gap-4 md:gap-8 items-baseline py-10 border-b border-[#262626] hover:px-4 transition-all duration-500" data-testid={`manifesto-${m.no}`}>
              <span className="md:col-span-2 font-mono text-sm text-[#C8A24B]">/ {m.no}</span>
              <h3 className="md:col-span-6 font-serif text-2xl sm:text-3xl lg:text-4xl text-[#F7F5F2] group-hover:text-[#C8A24B] transition-colors duration-500">
                {m.title}
              </h3>
              <p className="md:col-span-4 text-[#8C8C8C] leading-relaxed">{m.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
